import { matchPath, useLocation } from "react-router-dom";

import { ROUTES } from "routing/routes";

export function useGetActiveWordId() {
  const location = useLocation();
  const match = matchPath(location.pathname, {
    path: ROUTES.CLASSROOM.COURSE.VOCABULARY.SESSION.path
  }) as any;

  return match ? match.params.wordId : undefined;
}
